/**
* Author: DanSmile
* Date: 2019/8/7
* Time: 18:53
*/
<template>
   <div></div>
</template>

<script>
    export default {
        data () {
            return {}
        },
        created () {
            this.$router.push('/');
        },
    }
</script>
